import { BaseCarouselTracking } from './BaseCarouselTracking';

export class GenericCarouselTracking extends BaseCarouselTracking {
    aalink = [];
    fathom = [];
    element = null;
    carousel_num = 0;
    link = null;
    url = '';
    constructor(aalink, fathom, elem, num, link) {
        super(aalink, fathom, elem, num, link);
        this.aalink = aalink;
        this.fathom = fathom;
        this.element = elem;
        this.carousel_num = num;
        this.link = link;
        this.url = link.getAttribute('href');
    }
    parse() {
        //if(CBS.Registry.user.id === null && carousel_num >= 4) { } - we may need this
        let isMovie = this.fathom.includes('movie');
        let movieGenre = this.link.getAttribute('data-genre');
        let isOnNow = this.aalink[0] == 'on now';

        let parser = new DOMParser();
        let fakeDom = parser.parseFromString('<!doctype html><body>' + this.aalink[0], 'text/html');
        let trackingTitle = fakeDom.body.textContent;
        trackingTitle =
            (trackingTitle && trackingTitle.length) > 0
                ? trackingTitle[0].toUpperCase() + trackingTitle.substring(1)
                : '';
        trackingTitle = this.toTitleCase(trackingTitle);

        let sectionContainer = this.element.closest('.js-le-carousel');
        let _carouselId = sectionContainer.getAttribute('data-carouselid');
        let _carouselContentType = this.fathom[3] ?? (isMovie ? 'movie' : 'show');
        _carouselContentType = this.fathom.includes('brand') ? 'brand' : _carouselContentType;
        _carouselContentType =
            (this.aalink[21] === 'live-event' || isOnNow) && this.aalink[26]
                ? this.aalink[26]
                : _carouselContentType;
        let tTitle =
            trackingTitle ||
            decodeURI(sectionContainer.getAttribute('data-title')).replace(/\+/g, ' ') ||
            unescape(this.aalink[0]);

        if (isOnNow) {
            _carouselContentType = 'live';
        }

        let _carouselModel = sectionContainer.getAttribute('data-model');
        let _carouselPresentationStyle = sectionContainer.getAttribute('data-presentationstyle');
        let datatracking = this.element.hasAttribute('data-tracking')
            ? this.element.getAttribute('data-tracking').split('|')
            : [];
        let _screenName =
            document.querySelector('#global-header-container .user-profile-name')?.textContent ??
            '';

        if (this.aalink[18] === 'homeShowGroup') {
            //homeShowGroup does not have individual carouselIds/_carouselModels for the carousels. This is a bit of a hack.
            _carouselId = this.aalink[17];
            _carouselModel = this.aalink[18];
        }
        let relatedData;
        if (isMovie) {
            relatedData = {
                movieId: this.link.getAttribute('id') ?? '',
                movieTitle: this.fathom[5] ?? 'undefined',
                movieGenre: movieGenre,
                contentBadgeLabel: this.aalink[13] ?? 'undefined',
            };
        } else {
            relatedData = {
                showSeriesId: (this.aalink[11] ? this.aalink[11] : this.fathom[0]) ?? 'undefined', // if not movie & ID is not in aa-link, grab it from fathom
                showTitle: this.aalink[4] ?? 'undefined',
                showSeriesTitle: this.aalink[4] ?? 'undefined',
                showGenre: this.aalink[15] ?? 'undefined', // doesn't exist
                showDayPart: 'undefined', // doesn't exist
                showEpisodeId: this.aalink[21] !== 'live-event' ? this.aalink[16] : '',
                showEpisodeLabel: this.aalink[5],
                showEpisodeTitle: this.aalink[5],
                showSeasonNumber: this.aalink[6],
                showEpisodeNumber: this.aalink[7],
                contentBadgeLabel: this.aalink[13]?.length === 1 ? '' : this.aalink[13], // fix for live local channel lock badge CBSSITE-11518
            };
        }

        let obj = {
            contentBrand: this.aalink[10] !== '' ? this.aalink[10] : 'na',
            carouselId: _carouselId,
            carouselContentType: _carouselContentType,
            carouselModel: _carouselModel,
            carouselLink: this.url,
            rowHeaderTitle: unescape(tTitle),
            stationCode: this.aalink[16] ?? '',
            posRowNum: this.carousel_num ? this.carousel_num.toString() : 'null',
            posColNum: Number(this.aalink[3]).toString(),
            contentLocked: this.aalink[23] ? this.aalink[23] : '',
            liveTvChannel: this.getLiveTVChannel(),
            movieId: isMovie ? this.link.getAttribute('id') : '',
            movieTitle: isMovie ? this.fathom[5] : '',
            movieGenre: isMovie ? this.aalink[15] : '',
            showSeriesId: !isMovie ? this.link.getAttribute('id') : '',
            showTitle: !isMovie ? this.aalink[4] : '',
            showSeriesTitle: !isMovie ? this.aalink[4] : '',
            showEpisodeLabel: this.aalink[5],
            showEpisodeTitle: this.aalink[0] === 'on now' ? this.aalink[4] : '',
            showSeasonNumber: !isMovie ? this.aalink[6] : '',
            showEpisodeNumber: this.aalink[7],
            showAirDate: this.aalink[8],
            ctaText: this.aalink[2],
            targetURL: this.url,
            targetType: this.aalink[2] + '|' + this.url,
            screenName: _screenName,
            dma: this.aalink[24] ?? '',
            carouselPresentationStyle: _carouselPresentationStyle,
            ...relatedData,
        };

        if (_carouselModel === 'promotion') {
            obj.videoId = this.aalink[25] ?? '';
            obj.videoPreviewId = this.aalink[18] ?? '';
            obj.contentLocked = this.aalink[17] ?? '';
            obj.streamStartTimestamp = this.aalink[26] ?? '';
            obj.streamEndTimestamp = this.aalink[27] ?? '';
            obj.contentStatus = this.aalink[28] ?? '';
            obj.isHighlightEnabled = 'false';
            obj.spliceEnabled = '0';
            obj.showSeriesId = this.aalink[6] ?? '';
            obj.showSeriesTitle = this.aalink[14] ?? '';
            obj.showSeasonNumber = this.aalink[7] ?? '';
            obj.showEpisodeTitle = this.aalink[5] ?? '';
            obj.showEpisodeId = this.aalink[20] ?? '';
            obj.posRowNum = $(sectionContainer).data('position') ?? '';
        }

        if (_carouselPresentationStyle === 'default_numeric') {
            obj.carouselItemTotal = this.aalink[28] ?? '';
        }

        if (this.aalink[0] === 'on now') {
            localStorage.setItem(
                'on_now_carousel',
                JSON.stringify({
                    liveTvChannel: obj.liveTvChannel,
                    stationCode: obj.stationCode,
                }),
            );
        }

        // badge type and lock state (if set) @todo duplicate in hero.js reuse?

        if (this.aalink[13] !== '') {
            obj[this.aalink[13] === 'p' ? 'PPlusSubscriberBadge' : 'TVELockedBadge'] =
                this.aalink[14];
        }

        return obj;
    }
    toTitleCase(str) {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1);
        });
    }
    getLiveTVChannel() {
        return (this.aalink[0] === 'on now') | (this.aalink[21] === 'live-event') ||
            this.aalink[21] === 'upcoming-event'
            ? (this.aalink[15] ?? '')
            : '';
    }
}
